import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=dea164dc&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dea164dc')) {
      api.createRecord('dea164dc', component.options)
    } else {
      api.reload('dea164dc', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=dea164dc&", function () {
      api.rerender('dea164dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CryTmaWByxsG/JS/imageCarousel.vue"
export default component.exports